import React, { useState } from 'react';
import { useDidMount } from '../../utils/hooks';
import { getDirection, pexios } from "../../utils/functions";
import SearchablePicker from "./SearchablePicker";
import { useTranslation } from 'react-i18next';

export default function CarSelect({ data, required, onChange }) {
    const { t, i18n } = useTranslation();

    const [carTypes, setCarTypes] = useState([]);
    const [carBrands, setCarBrands] = useState([]);
    const [carModels, setCarModels] = useState([]);

    useDidMount(() => {
        pexios('api/car_type')
            .then(res => {
                setCarTypes(res.data);
            });
        const { carType, carBrand } = data;
        if (carType && carBrand) {
            pexios(`api/car_brand/${carType}`)
                .then(res => {
                    setCarBrands(res.data);
                });
            pexios(`api/car_model/${carBrand}`)
                .then(res => {
                    setCarModels(res.data);
                });
        }
    });

    function selectCarType(type) {
        setCarBrands([]);
        setCarModels([]);
        onChange(type, 'car_type_id')
        onChange(null, 'car_brand_id')
        onChange(null, 'car_model_id')
        pexios(`api/car_brand/${type}`)
            .then(res => {
                setCarBrands(res.data);
            });
    }
    function selectCarBrand(brand) {
        setCarModels([]);
        onChange(brand, 'car_brand_id')
        onChange(null, 'car_model_id')
        pexios(`api/car_model/${brand}`)
            .then(res => {
                setCarModels(res.data);
            });
    }
    return (
        <>
            <SearchablePicker
                label={t('Car type')}
                value={data.carType}
                data={carTypes}
                titleKey='name'
                valueKey='id'
                rtl={getDirection(i18n.language) ==='rightToLeft'}
                required={required}
                onSelect={selectCarType}
            />
            <SearchablePicker
                label={t('Car brand')}
                value={data.carBrand}
                data={carBrands}
                titleKey='name'
                valueKey='id'
                rtl={getDirection(i18n.language) ==='rightToLeft'}
                required={required}
                onSelect={selectCarBrand}
            />
            <SearchablePicker
                label={t('Car model')}
                value={data.carModel}
                data={carModels}
                titleKey='name'
                valueKey='id'
                rtl={getDirection(i18n.language) ==='rightToLeft'}
                required={required}
                onSelect={model => onChange(model, 'car_model_id')}
            />
        </>
    );
}
